import React from 'react';
import PropTypes from 'prop-types';

function Expand({ size = 40, className, onClick, state = false }) {
  return (
    <svg className={className} width={size} height={size} onClick={onClick} style={{cursor: `pointer`}} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="20" cy="20" r="20" fill="#242424"/>
      <path d="M27 14H13C11.9 14 11 14.9 11 16V24C11 25.1 11.9 26 13 26H27C28.1 26 29 25.1 29 24V16C29 14.9 28.1 14 27 14ZM27 24H13V16H27V24Z" fill={state ? "#34B642" : "white"}/>
    </svg>
  )
}

Expand.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  state: PropTypes.bool.isRequired
}

export default Expand;
